var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-year-panel"},[_c('h3',{staticClass:"timeline-year-panel__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"timeline-year-panel__content"},[_vm._l((_vm.child),function(item){return [_c('timeline-mouth',{key:item.title,attrs:{"data":item}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }